
// Widget Scripts
import videoWidget from './js/widgets/videoWidget.js';
import tier2Slideshow from './js/widgets/tier2Slideshow.js';
import cardsSection from './js/widgets/cardsSection.js';
import seoBlock from './js/widgets/seoBlock.js';
import infographicSection from './js/widgets/infographicSection.js';
import diamondSponsors from './js/widgets/diamondSponsors.js';
import sponsors from './js/widgets/sponsors.js';
import microModal from './js/widgets/microModal.js';

import './js/widgets/videoWidgetSimple.js';
import videoWidgetSecond from './js/widgets/videoWidgetSecond.js';

// Aos Library
import AOS from 'aos';
import 'aos/dist/aos.css';

// Custom Theme Scripts
import './js/localjs.js';
import './js/subpagesBanner.js';
import './js/featureLineUp.js';

// Initialize Homepage Widgets


if (window.location.pathname === '/') {
  $(document).ready(function () {
    microModal();

    $(window).load(function () {
      videoWidget();
    })

    tier2Slideshow();
    cardsSection();
    seoBlock();

    $(window).load(function () {
      setTimeout(() => {
        videoWidgetSecond();
      }, 5000);
    })

    infographicSection();
    diamondSponsors();
    sponsors();

  });

}

$(document).ready(function () {
  setTimeout(() => {
    AOS.init({
      anchorPlacement: 'bottom-bottom',
      animatedClassName: 'aos-animate',
      initClassName: 'aos-init',
    });
  }, 3000)
})
